import React from 'react';

/**
 * Skeleton loader for dashboard stat values.
 * Renders a square, shimmering inline block.
 */
export function DashboardStatSkeleton() {
  return (
    <div
      className="admin-skeleton"
      style={{
        height: '28px',
        width: '80px',
        borderRadius: '0',
        display: 'inline-block'
      }}
    />
  );
}

/**
 * Skeleton loader representing a bar chart.
 * Renders 12 shimmering columns of randomized heights with flat, square corners.
 */
export function DashboardChartSkeleton() {
  // Generate pseudo-random stable heights for the columns
  const heights = [35, 60, 42, 85, 50, 75, 90, 48, 65, 38, 70, 55];
  
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        paddingLeft: '20px',
        display: 'flex',
        alignItems: 'flex-end',
        gap: '8px',
        boxSizing: 'border-box'
      }}
    >
      {heights.map((h, i) => (
        <div
          key={i}
          className="admin-skeleton"
          style={{
            flex: 1,
            borderRadius: '0',
            height: `${h}%`
          }}
        />
      ))}
    </div>
  );
}
